module.exports = __webpack_public_path__ + "img/SketchPngcdda314e1acd1a34bdc59b58990099c11b2b5edf3156159e051c877d22e08726.6b2443d5.png";